module.exports = __webpack_public_path__ + "img/icon-66.4082d56c.svg";